<template>
  <div class="page-entry">
    <com-header class="com-header" v-if="!isHideHeader" />
    <div class="page-body" :style="{'padding-top': isHideHeader ? 0 : '52px' }">
      <com-menu v-if="!$route.meta.hideMenu" @onFixed="onFixed" />
      <div
        class="page-body-main"
        :class="{
          fixed: isFixed,
          'hide-menu': $route.meta.hideMenu,
          'black-background': $route.meta.title === '监课看板'
        }"
      >
        <com-breadcrumb v-if="!$route.meta.hideBreadcrumb && $route.meta.title !== '监课看板'" />
        <div class="page-body-content" :class="{hideBreadcrumb: $route.meta.hideBreadcrumb, 'padding-none': isHideHeader}">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ComHeader from '@/components/ComHeader'
import ComMenu from '@/components/ComMenu'
import ComBreadcrumb from '@/components/ComBreadcrumb'

export default {
  name: 'Entry',
  data () {
    return {
      isFixed: false // 是否固定导航
    }
  },
  components: {
    ComHeader,
    ComMenu,
    ComBreadcrumb
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo/userInfo'
    }),
    isHideHeader() {
      return this.$route.meta.hideHeader === 1
    }
  },
  provide () {
    return {
      userInfo: this.userInfo
    }
  },
  methods: {
    onFixed(val) {
      this.isFixed = val
    }
  }
}
</script>

<style lang="less">
@import '~@/static/css/base.less';
.black-background {
  background: #242731;
}

.full-screen {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
}

.page-entry {
  height: 100%;
  color: @gray-2;

  .com-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
  }

  .page-body {
    display: flex;
    height: 100%;
    // padding-top: 52px;

    .page-body-main {
      display: flex;
      flex-direction: column;
      flex: 1;
      height: 100%;
      width: 100%;
      padding-left: 45px;
      &.hide-menu {
        padding: 0;
      }

      &.fixed {
        padding-left: 0;
        overflow: hidden;
      }

      .page-body-content {
        flex-grow: 1;
        padding: 0 20px;
        overflow: auto;
      }
      .padding-none {
        padding: 0;
      }
    }
  }
}
</style>
